import React, { useEffect, useMemo } from "react"
interface ProSelectTextOption<T> {
  value: T
  label: string
}
interface ProSelectTextProps<T extends string | number> {
  label?: string
  /**
   * 是否默认选中第一个选项，默认false
   */
  defaultSelectedFirstOption?: boolean
  /**
   * 没有内容时显示的文本，默认'please select'
   */
  defaultText?: string
  icon?: React.ReactNode
  options: ProSelectTextOption<T>[]
  value: T
  onChange(value: T): void
}

import { ActionList, Icon, Popover } from "@shopify/polaris"
import { ChevronDownIcon, ChevronUpIcon } from "@shopify/polaris-icons"
import { useState } from "react"

function ProSelectText<T extends string | number>(
  props: ProSelectTextProps<T>,
) {
  const [popoverActive, setPopoverActive] = useState(false)
  const {
    label = "",
    options = [],
    value,
    defaultSelectedFirstOption = false,
    icon,
    onChange,
    defaultText = "please select",
  } = props

  const optionsMap = useMemo(() => {
    return options.reduce((pre, item) => {
      pre[item.value as string] = item.label
      return pre
    }, {})
  }, [options])

  useEffect(() => {
    if (defaultSelectedFirstOption && options.length > 0) {
      onChange(options[0].value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelectedFirstOption, options])

  useEffect(() => {
    return () => {
      setPopoverActive(false)
    }
  }, [])

  const text: string = useMemo(() => {
    return optionsMap[value as string] || defaultText
  }, [optionsMap, value, defaultText])

  return (
    <>
      <Popover
        preferredAlignment="right"
        active={popoverActive}
        activator={
          <div
            className="cursor-pointer inline-flex leading-5 whitespace-nowrap"
            onClick={() => {
              setPopoverActive((prev) => {
                return !prev
              })
            }}
          >
            <div className="flex items-center">
              {icon && <>{icon}</>}
              <div className="flex items-center">
                {label && (
                  <span className="pro-text-select__label">{label}:</span>
                )}
                <div className="flex items-center text-[var(--p-color-text-emphasis)] hover:text-[var(--p-color-text-emphasis-hover)]">
                  <span className="pro-text-select__text">
                    &nbsp;{text}&nbsp;
                  </span>
                  <span className="pro-text-select__icon">
                    <Icon
                      source={popoverActive ? ChevronUpIcon : ChevronDownIcon}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
        onClose={setPopoverActive.bind(null, false)}
      >
        <ActionList
          actionRole="menuitem"
          items={options.map((item) => {
            return {
              content: item.label,
              active: value == item.value,
              onAction: () => {
                setPopoverActive(false)
                onChange(item.value)
              },
            }
          })}
        />
      </Popover>
    </>
  )
}

export default ProSelectText
